<form [formGroup]="form">
    <div class="row produktspecifikation">
        <rask-selector
            class="col-2"
            [label]="texts.produktspecifikation"
            [disabled]="produktspecifikationDisabled"
            [values]="produktspecifikationerItems"
            [(ngModel)]="produkt.produktspecifikation"
            [ngModelOptions]="{ standalone: true }"
            [formatter]="produktspecifikationFormatter"
            [viewFormatter]="produktspecifikationViewFormatter"
            (change)="onProduktspecifikationChange($event)"
            aid="produktspecifikation">
        </rask-selector>
        <rask-datepicker
            class="col-2"
            formControlName="giltigFrom"
            [required]="true"
            [maxDate]="produktspecifikation.giltigTom"
            [label]="texts.giltigFrom"
            [rule]="validation.giltigFrom"
            aid="giltigFrom">
        </rask-datepicker>
        <rask-datepicker
            class="col-2"
            formControlName="giltigTom"
            [label]="texts.giltigTom"
            [rule]="validation.giltigTom"
            [minDate]="produktspecifikation.giltigFrom"
            aid="giltigTom">
        </rask-datepicker>
    </div>
</form>
